import React, { FC } from 'react';

import { fontFamilies } from 'components/UI/Font';
import { useUrlBuilder } from 'hooks/useUrlBuilder';

import Departments from '../../../../../../models/departments';

import { Card } from './Card';

export const MoreProductsCard: FC<{ brandName: string; brandUrl: string; department: string }> = ({
  brandName,
  brandUrl,
  department,
}) => {
  const { localized, withTrailingSlash } = useUrlBuilder();

  const urlDepartmentName = Departments.getKidsDepartmentsInternalNames().includes(department.toLowerCase())
    ? 'kids'
    : department;
  return (
    <>
      <Card>
        <a href={`${withTrailingSlash(localized(brandUrl))}${urlDepartmentName}/`}>
          <div className="view-more">
            View more from <span>{brandName}</span>
          </div>
        </a>
      </Card>
      <style jsx>{`
        .view-more {
          font-size: 15px;
          padding: 165px 10px 0 10px;
          height: 350px;
          white-space: normal;
        }

        .view-more span {
          font-family: ${fontFamilies.bold};
          font-size: 15px;
        }
      `}</style>
    </>
  );
};
